__turbopack_context__.v({
  "carousel-container": "LZvfta_carousel-container",
  "carousel-section": "LZvfta_carousel-section",
  "connector": "LZvfta_connector",
  "connector-dot": "LZvfta_connector-dot",
  "connector-line": "LZvfta_connector-line",
  "container": "LZvfta_container",
  "content": "LZvfta_content",
  "heading": "LZvfta_heading",
  "logo": "LZvfta_logo",
  "logo-section": "LZvfta_logo-section",
  "slide": "LZvfta_slide",
  "slide-center": "LZvfta_slide-center",
  "slide-content": "LZvfta_slide-content",
  "slide-image": "LZvfta_slide-image",
  "slide-left": "LZvfta_slide-left",
  "slide-name": "LZvfta_slide-name",
  "slide-overlay": "LZvfta_slide-overlay",
  "slide-overlay-left": "LZvfta_slide-overlay-left",
  "slide-overlay-right": "LZvfta_slide-overlay-right",
  "slide-right": "LZvfta_slide-right",
  "slide-title": "LZvfta_slide-title",
  "slide-wrapper": "LZvfta_slide-wrapper",
  "subheading": "LZvfta_subheading",
  "text-section": "LZvfta_text-section",
});
